<template>
  <div>
    <h1>Usuários</h1>
    <v-divider class="my-5"></v-divider>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          type="text"
          v-model="search"
          label="Buscar por"
          prepend-inner-icon="mdi-account-search"
          append-outer-icon="mdi-send"
          @click:append-outer="loadUsers()"
          @keydown="validateSearch($event)"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Nome
          </th>
          <th class="text-left">
            E-mail
          </th>
          <th class="text-left">
            Perfis
          </th>
          <th class="text-left">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="user in users"
          :key="user.id"
        >
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ getRolesView(user) }}</td>
          <td>
            <v-btn text :to="{ name: 'EditUser', params: { userId: user.id }}" color="success">
              <v-icon left>mdi-pencil</v-icon>
              Editar
            </v-btn>
            <v-btn text :to="{ name: 'EnrolmentsUser', params: { userId: user.id }}" color="primary">
              <v-icon left>mdi-ticket-account</v-icon>
              Matrículas
            </v-btn>
            <v-btn text disabled color="error">
              <v-icon left>mdi-delete</v-icon>
              Remover
            </v-btn>
            <v-btn text @click="downloadPrivateKey(user.id)">
              <v-icon left>mdi-file-key</v-icon>
              Chave privada
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-alert v-if="!users.length" type="info">
      Nenhuma usuário encontrado.
    </v-alert>
    <div class="text-center mt-10">
      <v-pagination
        v-model="pagination.currentPage"
        :length="pagination.totalPages"
        :total-visible="7"
        @input="changePage()"
        circle
      ></v-pagination>
    </div>
    <v-btn
      :to="{ name: 'CreateUser' }"
      color="success"
      fab
      x-large
      right
      bottom
      fixed
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AdminUserService from '@/services/admin-user/admin-user.service';
import AdminStudentService from '@/services/admin-student/admin-student.service';

const userService = new AdminUserService();
const studentService = new AdminStudentService();

export default {
  name: 'AdminUsers',
  data: () => ({
    users: [],
    search: '',
    pagination: {
      currentPage: 1,
      itemCount: 0,
      itemsPerPage: 10,
      totalItems: 0,
      totalPages: 1,
    },
  }),
  mounted() {
    this.loadUsers();
  },
  methods: {
    loadUsers() {
      userService.getUsers(this.search, this.pagination.currentPage, this.pagination.itemsPerPage)
        .then((response) => {
          this.users = response.data.items;
          this.pagination = response.data.meta;
        })
        .catch(console.error);
    },
    downloadPrivateKey(userId) {
      studentService.privateKey(userId)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          const url = window.URL.createObjectURL(blob)
          window.open(url);
        });
    },
    changePage() {
      this.loadUsers();
    },
    validateSearch(event) {
      if (event.keyCode === 13) {
        this.loadUsers();
      }
    },
    getRolesView(user) {
      return user.roles.map((role) => {
        switch (role) {
          case 'admin':
            return 'Administrador';
          case 'teacher':
            return 'Professor';
          case 'student':
            return 'Estudante';
          default:
            return 'Desconhecido';
        }
      }).join(', ');
    },
  },
};
</script>

<style>

</style>
